(function () {
  var tip = null;
  var currentEl = null;
  var raf = false;

  function showTip(el) {
    if (currentEl === el) return;
    hideTip();
    var text = el.getAttribute('data-tooltip');
    if (!text) return;
    currentEl = el;
    tip = document.createElement('div');
    tip.className = 'badge-tooltip-float';
    tip.textContent = text;
    document.body.appendChild(tip);
    // Double rAF pour laisser le browser wrap le texte et calculer la taille finale
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { if (currentEl === el) positionTip(el); });
    });
  }

  function positionTip(el) {
    if (!tip) return;
    var rect = el.getBoundingClientRect();
    var tw = tip.offsetWidth;
    var th = tip.offsetHeight;
    var left = rect.left + rect.width / 2 - tw / 2;
    var top  = rect.top - th - 8;
    if (left < 8) left = 8;
    if (left + tw > window.innerWidth - 8) left = window.innerWidth - tw - 8;
    if (top < 8) top = rect.bottom + 8;
    tip.style.left = left + 'px';
    tip.style.top  = top  + 'px';
  }

  function hideTip() {
    if (tip) { tip.remove(); tip = null; }
    currentEl = null;
  }

  // mousemove sur document : contourne le z-index overlay (full-unstyled-link::after)
  // qui bloque les mouseenter/mouseleave sur les badges
  document.addEventListener('mousemove', function (e) {
    if (raf) return;
    raf = true;
    requestAnimationFrame(function () {
      raf = false;
      var badges = document.querySelectorAll('[data-tooltip]');
      var found = null;
      for (var i = 0; i < badges.length; i++) {
        var r = badges[i].getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right &&
            e.clientY >= r.top  && e.clientY <= r.bottom) {
          found = badges[i];
          break;
        }
      }
      if (found) showTip(found);
      else hideTip();
    });
  });

  document.addEventListener('mouseleave', hideTip);

  // Focus/blur pour l'accessibilité clavier
  function bind() {
    document.querySelectorAll('[data-tooltip]').forEach(function (el) {
      if (el._tipBound) return;
      el._tipBound = true;
      el.addEventListener('focus', function () { showTip(el); });
      el.addEventListener('blur',  hideTip);
    });
  }

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
  var obs = new MutationObserver(bind);
  document.addEventListener('DOMContentLoaded', function () {
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
